import ClientMonthlyRebateReport from './ClientMonthlyRebateReport';
import DistributorAgentMonthlyRebateReport from './DistributorAgentMonthlyRebateReport';

export default {
  clientReport: ClientMonthlyRebateReport,
  DistributorReport: DistributorAgentMonthlyRebateReport,
};
